module.exports = __webpack_public_path__ + "static/media/IndicaDomCG.6b615e08.png";